<template>
  <v-container fluid>
    <v-card elevation="2" :class="{'mb-5': allowCopy}">
      <v-card-title class="display-1">Customers</v-card-title>

      <data-filter
        :dateFrom="date.from"
        :dateTo="date.to"
        :loading="loading"
        :selectables="selectables"
        :filters="filterOptions"
        @updatePeriod="(val)=>{date = val}"
        @updateFilters="(val)=>{filterValues = val}"
        @search="filterTable"
        is-filter-date
        date-clearable
      ></data-filter>

      <v-data-table
        :loading="loading"
        :items="list"
        :headers="headers"
        :footer-props="{'items-per-page-options': [15, 30, 50, 100]}"
        :options.sync="pagination"
        :search="search"
        hide-default-footer
        mobile-breakpoint="0"
      ></v-data-table>

      <v-divider></v-divider>

      <v-card-actions v-if="!loading">
        <paginator
          :pagination.sync="pagination"
          :total-items="totalItems"
          :items-per-page-options="itemsPerPageOptions"
        ></paginator>
      </v-card-actions>
    </v-card>

    <v-btn
      transition="scale-transition"
      v-if="allowCopy"
      fixed
      dark
      fab
      bottom
      right
      color="pink"
      @click.native="exportAsExcel"
    >
      <v-icon>cloud_download</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
  import { map, get } from 'lodash'
  import XLSX from 'xlsx'

  import Paginator from '@/components/Paginator'
  import DataFilter from '@/components/Common/DataFilter'

  import paginationMixin from '@/mixins/pagination'

  export default {
    props: {
      transactionService: Object,
    },
    mixins: [
      paginationMixin,
    ],

    components: {
      Paginator,
      DataFilter,
    },

    data () {
      return {
        loading: false,
        search: null,
        list: [],

        date: {
          from: null,
          to: null,
        },
        filterValues: {},
        selectables: {
          channels: [
            { text: 'SMS', value: 'sms' },
            { text: 'Email', value: 'mail' },
          ],
        },
        filterOptions: {
          channel: {
            items: 'channels',
            text: 'Channel',
          },
          recipient: {
            type: 'text',
            text: 'Recipient',
          },
        },

        headers: [
          {
            text: 'Recipient',
            value: 'recipient',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Receipt Channel',
            value: 'channel',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Reject EDM',
            value: 'reject_edm',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Reject Partner EDM',
            value: 'reject_partner_edm',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Total Purchased ($)',
            value: 'total_amount',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Credits Redeemed',
            value: 'credits_used',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Credits Left',
            value: 'remaining_credits',
            align: 'left',
            sortable: false,
          },
        ],
      }
    },

    computed: {
      allowCopy () {
        return !this.loading && this.list.length !== 0
      },
    },

    created () {
      this.updateTable()
    },

    methods: {
      async updateTable () {
        if (this.loading) {
          return
        }

        this.loading = true
        this.list = []

        this.filters = {
          ...this.date,
          ...this.filterValues,
        }

        const { data } = await this.fetchData()
        this.loading = false
        this.list = data.data
        this.totalItems = data.meta.total
      },

      async fetchData (limit = null) {
        const params = this.transformPaginationParams()
        if (limit) {
          params.limit = limit
        }
        const { data } = await this.transactionService.listUsers(params)
        return data
      },

      async exportAsExcel () {
        let list = this.list

        if (this.totalItems > this.pagination.itemsPerPage) {
          // Current list is paginated
          list = await this.fetchData(-1).then(({ data }) => {
            return data.data
          })
        }

        const headerValues = map(this.headers, 'value')
        list = list.map(item => headerValues.map(key => get(item, key)))

        const ws = XLSX.utils.aoa_to_sheet([
          map(this.headers, 'text'),
          ...list,
        ])

        const wb = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(wb, ws)

        XLSX.writeFile(wb, 'clients.xlsx')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/TransactionUser/TransactionUserList.vue